/*LIBRARY*/
import { useState, useEffect, useContext } from "react";
import { connect } from "react-redux";

/*COMPONENT*/

/*REDUX*/
import { edit_css_bi, set_value_bi } from "../../App/actions/biActions";

/*PICTURE*/

/*FUNCTION*/
import css_string_init from "./css_string_init";
import { ErrorContext } from "../../Debug/ErrorHandler/ErrorContext";

/*DATA*/
import dict from "../../Data/dict.json";

/*CONST*/

const BI_EDIT_CSS = ({ auth, bi, edit_css_bi, set_value_bi }) => {
  const [css_string, set_css_string] = useState(css_string_init());

  const { handleError } = useContext(ErrorContext);

  useEffect(() => {
    const { bi_object } = bi;
    if (bi_object?.css_string) {
      set_css_string(bi_object?.css_string);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const on_change = (e) => {
    handleError(() => {
      set_css_string(e.target.value);
    })();
  };

  const on_edit_css_bi = () => {
    handleError(() => {
      const { bi_object } = bi;
      const body = {
        _id: bi_object._id,
        css_string,
      };
      edit_css_bi(body);
    })();
  };

  const on_close_css = () => {
    handleError(() => {
      set_value_bi({
        key: "modal_edit_css",
        value: false,
      });
    })();
  };

  //local storage
  const language = localStorage?.language || auth.language;

  //local state
  // Already destructured from useState

  //global props
  // Already destructured in arguments

  //content

  return (
    <main>
      <section>
        <h1 className="margin_bottom">
          {dict?.["CSS for layout editor"]?.[language]}
        </h1>
        <button
          className="button button_white margin_bottom margin_right"
          onClick={on_edit_css_bi}
        >
          {dict?.["Save"]?.[language]}
        </button>
        <button
          className="button button_white margin_bottom margin_right"
          onClick={on_close_css}
        >
          {dict?.["Close"]?.[language]}
        </button>
      </section>
      <textarea
        className="bi_input_css"
        onChange={on_change}
        value={css_string}
        name="css_string"
      />
    </main>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  bi: state.bi,
});

export default connect(mapStateToProps, { edit_css_bi, set_value_bi })(
  BI_EDIT_CSS
);
